import { HTTPClientFactory } from '@bty/http-client'

export const REQUEST_TIMEOUT = 60 * 1000

export const httpClientFactory = new HTTPClientFactory()
